import { LoadablePaint } from '@confluence/loadable';

export const LazyMacroUsagePage = LoadablePaint({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-MacroUsageContainer" */ '../src/MacroUsage/MacroUsagePage.tsx'
			)
		).MacroUsagePage,
});
